
// @ts-nocheck


export const localeCodes =  [
  "en",
  "it"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_df5aac62",
      load: () => import("#nuxt-i18n/df5aac62" /* webpackChunkName: "locale_en_46ts_df5aac62" */),
      cache: false
    }
  ],
  it: [
    {
      key: "locale_it_46ts_5a661957",
      load: () => import("#nuxt-i18n/5a661957" /* webpackChunkName: "locale_it_46ts_5a661957" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/app/i18n/lang/en.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      files: [
        {
          path: "/app/i18n/lang/it.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "it",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "lang/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/app/i18n/lang/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    files: [
      {
        path: "/app/i18n/lang/it.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/